import type { UploadedFile } from 'models';
import { useTranslation } from 'react-i18next';
import { Button, Collapse, InputFileAttachment, Text } from 'ui';

type P = {
  attachments: UploadedFile[];
  onClear: () => void;
  onRemove: (attachment: UploadedFile) => void;
};

const FileAttachments = ({ attachments, onClear, onRemove }: P) => {
  const { t } = useTranslation();

  if (attachments.length > 1) {
    return (
      <Collapse
        classNames={{ body: 'file-attachments__collapse-body', root: 'file-attachments__collapse' }}
        defaultActiveKey="attachments-key"
        ghost
      >
        <Collapse.Panel
          extra={
            <Button onClick={onClear} type="link-primary">
              Clear all
            </Button>
          }
          header={<Text>{t('Attachments ({{count}})', { count: attachments.length })}</Text>}
          key="attachments-key"
        >
          {attachments.map((attachment) => (
            <InputFileAttachment
              attachment={attachment}
              key={attachment.id}
              onRemove={() => {
                onRemove(attachment);
              }}
            />
          ))}
        </Collapse.Panel>
      </Collapse>
    );
  }

  return (
    <>
      {attachments.map((attachment) => (
        <InputFileAttachment
          attachment={attachment}
          key={attachment.id}
          onRemove={() => {
            onRemove(attachment);
          }}
        />
      ))}
    </>
  );
};

export default FileAttachments;
